<template>
  <b-card
    v-if="item"
    class="boxNews pb-0 mb-1"
    style="height: 100%; max-height: 415px;"
    no-body
  >
    <b-card-header class="p-1 backgroundCardHeader">
      <div class="col-12 p-0 row d-flex">
        <div class="col-10">
          <h3 class="card-title justify-content-start">
            <router-link
              :to="{ name: 'home-category', params: { slug: item.slug } }"
              class="d-flex align-items-center"
              :title="item.name"
            >
              <span :class="renderIconCategory(item.name)" />
              <span class="font-be-vietnam font-size20-be-vietnam text-dark font-weight-700 ml-1">{{ capFirst(item.name) }} </span>
              <span class="icon_arrow" /></router-link>
          </h3>
        </div>
        <div class="col-2">
          <router-link :to="{ name: 'home-category', params: { slug: item.slug } }">
            <span class="default_arrow ml-auto" />
          </router-link>
        </div>
      </div>
    </b-card-header>
    <b-card-body class="p-1">
      <swiper
        class="slider swiper-responsive-breakpoints"
        :options="swiperOption"
      >
        <swiper-slide
          v-for=" (data, index) in item.articles"
          :key="index"
        >
          <div class="itemSwiper">
            <router-link
              :to="{ name: 'home-view', params: { id: data.id, slug: data.slug } }"
              class="thumbnail"
              :title="data.title"
            >
              <b-img
                class="img_thumbnail"
                :src="data.image"
              />
            </router-link>
            <h3
              class="news-title"
              style="min-height: 76px;"
            >
              <router-link
                :to="{ name: 'home-view', params: { id: data.id, slug: data.slug } }"
                :title="data.title"
                class="trunc .trunc-3-1 trunc-2"
              >
                <span :class="renderClassTitleHot(data)"> {{ data.title }}</span>
                <span
                  v-if="data.hot"
                  class="iconHotGif"
                />
                <span
                  v-if="data.is_get"
                  class="iconNewsRead"
                /></router-link>
            </h3>
            <div class="news-icon col-12 d-flex p-0">
              <div class="w-30 d-flex pr-1">
                <span
                  v-for=" (type, key) in data.content_type"
                  :key="key"
                  class="mr-0"
                >
                  <span
                    v-if="type === 'audio'"
                    class="iconAudioBlue mr-0"
                  />
                  <span
                    v-if="type === 'photo'"
                    class="iconPhotoBlue mr-0"
                  />
                  <span
                    v-if="type === 'video'"
                    class="iconVideoBlue mr-0"
                  />
                </span>
              </div>
              <div class="w-70 d-flex  justify-content-end">
                <span> {{ (data.timeago) }}</span>
                <span
                  v-if="data.unit"
                  class="icon font-size13-be-vietnam"
                  style="padding-left: 10px;"
                > {{ showListPart(data.unit) }}</span>
              </div>

            </div>
          </div>
        </swiper-slide>
        <!-- <div
          slot="button-next"
          class="swiper-button-next"
        />
        <div
          slot="button-prev"
          class="swiper-button-prev"
        /> -->
      </swiper>
    </b-card-body>
  </b-card>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { ref } from '@vue/composition-api';
import {
  BOverlay,
  BCardBody,
  BCard,
  BImg,
  BLink,
  BCardHeader,
} from 'bootstrap-vue';
import 'swiper/css/swiper.css'
import { timeago } from '@/libs/helper';

export default {
  components: {
    Swiper,
    SwiperSlide,
    BOverlay,
    BCard,
    BCardBody,
    BLink,
    BImg,
    BCardHeader,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    showIcon: {
      type: String,
      default: 'FileTextIcon',
    },
  },
  setup(props, context) {
    // console.log('props_slide', props)
    const swiperOption = ref({
      slidesPerView: 5,
      spaceBetween: 5,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 5,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    });
    return {
      swiperOption,
    }
  },
  methods: {
    resolveTimeago(time) {
      return timeago(time);
    },
    showListPart(str) {
      return str.split(',').slice(0, 3).join(',');
    },
    renderClassTitleHot(item) {
      // 1. Tin bình thường mầu đen

      // 2. Tin đã click màu ghi
      // 3. Tin hot màu đỏ tười có iconhot
      // 4. TIn đã lấy màu nâu đỏ có icon xanh
      // 5. Tin hot đã click màu ghi có icon hot
      // 6. TIn hot đã lấy màu nâu đỏ có icon xanh, icon hot
      let classTitle = 'class_title_normall';
      if (item.hot) {
        if (item.is_get) { // đã lấy thì đã đọc
          if (item.is_view) {
            classTitle = 'class_title_hot_get_view'
          } else {
            classTitle = 'class_title_hot_get_notview'
          }
        } else if (!item.is_get) { // tin chưa lấy những có thể đọc hoặc chưa đọc
          if (item.is_view) {
            classTitle = 'class_title_hot_notget_view'
          } else {
            classTitle = 'class_title_hot_notget_notview' // tin hot chưa lấy chưa đọc
          }
        }
      } else if (!item.hot) {
        if (item.is_get) { // tin đã lấy thì đã đọc
          if (item.is_view) {
            classTitle = 'class_title_nothot_get_view'
          } else {
            classTitle = 'class_title_nothot_notget_notview'
          }
        } else if (!item.is_get) {
          if (item.is_view) { // tin bt nhưng đã xem chưa lấy
            classTitle = 'class_title_nohot_notget_view'
          } else {
            classTitle = 'class_title_nohot_notget_notview'
          }
        }
      }

      return classTitle;
    },
    renderIconCategory(name) {
      let classIcon = 'tin_ban_trong_nuoc';
      if (typeof name !== 'string' || name === undefined) {
        return classIcon;
      }
      const pattern = /thao/i;
      if (name.match(pattern)) {
        classIcon = 'tin_the_thao'
      }

      return classIcon;
    },
    capFirst(str) {
      const str1 = (str || '').toLowerCase()
      if (str1[0] !== undefined) {
        return str1[0].toUpperCase() + str1.slice(1);
      }
      return str
    },
  },
}
</script>
<style lang="scss">
.boxNews {
  .itemSwiper {
    .thumbnail {
      padding-top: 50%;
      background-color: #fff;
      position: relative;
      display: block;
      overflow: hidden
    }

    .img_thumbnail {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      object-fit: contain
    }
  }
}
</style>
